module.exports = __webpack_public_path__ + "static/media/netflix_logo.7649b0de.jfif";